import { api } from "../Apis/interceptor";

export const forgetPassword = function (userInfo) {
  return api.get("/api/userCheck/", {
    params: { userData: JSON.stringify(userInfo) },
  });
};

export const changePassword = function (id, userPass) {
  return api.get("/api/changePassword", {
    params: { user_id: id, resetData: JSON.stringify(userPass) },
  });
};
